import { useCallback, useMemo } from "react";

import { PAGER_INITIAL_PAGE_SIZE } from "shared/components/data-display/tables/Pager";
import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const useAbsenseReasons = () => {
    const { getDataAsync } = useApi();

    const getAbsenseReasonsApiCall = useCallback(async ({
        pageSize = PAGER_INITIAL_PAGE_SIZE,
        sortBy = "",
        pageIndex = 0,
        active = "",
    }) => {
        const response = await getDataAsync("getAbsenseReasons", {
            urlParams: [
                { name: "$sortBy", value: sortBy },
                { name: "$pageSize", value: pageSize },
                { name: "$pageNumber", value: pageIndex + 1 },
                { name: "$active", value: active },
            ],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;
    },
        [getDataAsync]
    );

    return useMemo(() => {
        const useAbsenseReasonsList = (dataObj) =>
            useQuery(
                ["absenseReasonsList", dataObj],
                () => getAbsenseReasonsApiCall(dataObj),
                { keepPreviousData: true, staleTime: Infinity }
            );
        return {
            useAbsenseReasonsList
        };
    }, [getAbsenseReasonsApiCall]);

}

export default useAbsenseReasons;
